import React from 'react';
import PropTypes from 'prop-types';

// Phase C.7.3 (Candidate Dashboard & Application Progress UX Modernization, §11): C.7.2's own
// component-inventory audit found the `--btn-*` tokens (themes.scss) already defined but completely
// unconsumed — every live button instead used the older `.button-global`/`.button-primary`/
// `.button-secondary`/`.button-border` string-concatenated classes. This is that missing reusable,
// token-driven primitive, built to the exact hierarchy §11 asks for (Primary/Secondary/Tertiary/
// Danger/Disabled/Loading). Deliberately scoped to the candidate dashboard (HomePageSummary_new.jsx)
// only — the 8 individual application forms still use `.button-global` untouched, per §21/§28's
// explicit "do not touch the forms yet" boundary. Not a replacement for `.button-global` anywhere
// it's not already being swapped out by this same phase.
const Button = ({ variant = 'primary', loading, disabled, onClick, children, type = 'button', className, ...rest }) => (
  <button
    type={type}
    className={`ent-btn ent-btn-${variant}${className ? ` ${className}` : ''}`}
    onClick={onClick}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    {...rest}
  >
    {loading && <span className="ent-btn-spinner" aria-hidden="true" />}
    <span className="ent-btn-label">{children}</span>
  </button>
);

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit']),
  className: PropTypes.string,
  children: PropTypes.node
};

export default Button;
